import { useFilterRoomTypeContext } from "./filter-room-type.context";

export function FilterRoomType() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterRoomTypeContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}